module.exports = __webpack_public_path__ + "img/bs1.e7bf218d.jpg";